// third-party
import { FormattedMessage } from "react-intl";

// project import

// assets
import DashboardOutlined from "@ant-design/icons/DashboardOutlined";
import CatalogIcon from "@ant-design/icons/BookOutlined";
import GoldOutlined from "@ant-design/icons/GoldOutlined";
import LoadingOutlined from "@ant-design/icons/LoadingOutlined";
import MemberIcon from "@ant-design/icons/UserOutlined";
import MasterIcon from "@ant-design/icons/DatabaseOutlined";
import InstituteIcon from "@ant-design/icons/BankOutlined";
import MaterialIcon from "@ant-design/icons/ReadOutlined";
import PurchaseIcon from "@ant-design/icons/CreditCardOutlined";
import CircularIcon from "@ant-design/icons/QrcodeOutlined";
import SecurityScanOutlined from "@ant-design/icons/SecurityScanOutlined";
import FeeIcon from "@ant-design/icons/WalletOutlined";
import GlobalOutlined from "@ant-design/icons/GlobalOutlined";
import MailOutlined from "@ant-design/icons/MailOutlined";
import SettingOutlined from "@ant-design/icons/SettingOutlined";

// type
import { NavItemType } from "types/menu";

import { useGetMenu } from "api/menu";

const icons = {
  dashboard: DashboardOutlined,
  catalog: CatalogIcon,
  circular: CircularIcon,
  fee: FeeIcon,
  member: MemberIcon,
  institute: InstituteIcon,
  master: MasterIcon,
  material: MaterialIcon,
  purchase: PurchaseIcon,
  components: GoldOutlined,
  loading: LoadingOutlined,
  security: SecurityScanOutlined,
  siteContentMenu: GlobalOutlined,
  emailTemplate: MailOutlined,
  cms: SettingOutlined,
};

const loadingMenu: NavItemType = {
  id: "group-dashboard-loading",
  title: <FormattedMessage id="dashboard" />,
  type: "group",
  icon: icons.loading,
  children: [
    {
      id: "dashboard1",
      title: <FormattedMessage id="dashboard" />,
      type: "collapse",
      icon: icons.loading,
      children: [
        {
          id: "default1",
          title: "loading",
          type: "item",
          url: "/dashboard/default",
          breadcrumbs: false,
        },
        {
          id: "analytics1",
          title: "loading",
          type: "item",
          url: "/dashboard/analytics",
          breadcrumbs: false,
        },
      ],
    },
  ],
};

// ==============================|| MENU ITEMS - API ||============================== //

export function MenuFromAPI() {
  const { menu, menuLoading } = useGetMenu();

  if (menuLoading) return loadingMenu;

  const subChildrenList = (children: NavItemType[]) => {
    return children?.map((subList: NavItemType) => {
      return fillItem(subList);
    });
  };

  const itemList = (subList: NavItemType) => {
    const list = fillItem(subList);

    // if collapsible item, we need to feel its children as well
    if (subList.type === "collapse") {
      list.children = subChildrenList(subList.children!);
    }
    return list;
  };

  const childrenList: NavItemType[] | undefined = menu?.children?.map(
    (subList: NavItemType) => {
      return itemList(subList);
    }
  );

  const menuList = fillItem(menu, childrenList);
  return menuList;
}

function fillItem(item: NavItemType, children?: NavItemType[] | undefined) {
  return {
    ...item,
    title: <FormattedMessage id={`${item?.title}`} />,
    // @ts-ignore
    icon: icons[item?.icon],
    ...(children && { children }),
  };
}
